/* eslint-disable */
import React, { Component } from 'react'
import Timeline from 'react-visjs-timeline'
import moment from 'moment'
import zoomInIcon from '../../assets/zoom-in.svg'
import zoomOutIcon from '../../assets/zoom-out.svg'
import moveLeftIcon from '../../assets/moveLeftIcon.svg'
import moveRightIcon from '../../assets/moveRightIcon.svg'
import './resultTimeline.css'
import { Col, Row, UncontrolledTooltip } from 'reactstrap'

class ResultTimeline extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedIds: [],
      resultsData: this.props.resultsData
    }
    this.timeline = React.createRef();
    this.zoomIn = this.zoomIn.bind(this);
    this.zoomOut = this.zoomOut.bind(this);
    this.move = this.move.bind(this)
    this.createGroupData = this.createGroupData.bind(this)
    this.addGroups = this.addGroups.bind(this)
    this.addItems = this.addItems.bind(this)
    if (this.props.resultsData !== undefined && this.props.resultsData.length > 0) {
      this.createGroupData(this.props.resultsData)
    }
  }

  componentDidMount() {
    this._isMounted = true;
  }


  createGroupData = () => {
    let max_date = new Date(this.props.max)
    let max_range_date = new Date(max_date.setDate(max_date.getDate() + 1))
    let max_item_date = ''

    const groupsExample = {
      groups: [],
      items: [
      ],
      options: {
        zoomable: false,
        min: new Date(this.props.min),
        max: max_range_date,
        groupOrder: 'content',
      },
    }
    this.addGroups(groupsExample)
    max_item_date = this.addItems(groupsExample, max_item_date)
    let diff_dates = Math.trunc((max_range_date.getTime() - max_item_date.getTime()) / (1000 * 3600 * 24))
    if (diff_dates < 5) {
      groupsExample.options.max = new Date(max_date.setDate(max_date.getDate() + 5 - diff_dates))
      groupsExample.items.push({ id: 'background', content: '', start: max_range_date, end: max_date, type: 'background', className: 'negative' })
    }
    this.state = {
      timelineData: groupsExample,
      selectedIds: [],
    }
  }

  addItems = (groupsExample, max_item_date) => {
    let results_data = this.props.resultsData
    for (let i = 0; i < results_data.length; i++) {
      let result = results_data[i]
      let result_unit = result.sample.unit ? ', ' + result.sample.unit.description : ""
      let content = result.sample.location.room.room_name + result_unit
      let title = moment(new Date(result.sample.date_time)).format('MMMM D, YYYY HH:mm')
      let color = this.props.ctColorMapping[result.complex_type]
      groupsExample.items.push({
        id: i,
        group: result.complex_type,
        content: content,
        title: `<span class="text-bold">Sample ID: </span> ${result.sample.sample_id}<br> <span class="text-bold">DateTime: </span> ${title}`,
        start: result.sample.date_time,
        type: 'point',
        align: 'center',
        className: `ct-circle a${color.split('#')[1]}-ct a${color.split('#')[1]}-text`
      })
      max_item_date = max_item_date !== '' && (max_item_date.valueOf() > new Date(result.sample.date_time).valueOf()) ? max_item_date : new Date(result.sample.date_time)
    }
    return max_item_date
  }

  addGroups = (groupsExample) => {
    let groupColorMapping = this.props.ctColorMapping
    Object.keys(groupColorMapping).forEach((group) => {
      let color = groupColorMapping[group]
      if (this.props.ctCheckboxMapping[group]) {
        groupsExample.groups.push({
          id: group,
          content: `<div class=a${color.split('#')[1]}-box a${color.split('#')[1]}-text ></div>CT ${group}`,
          className: `group-text`
        })
      }
    })
  }

  render() {
    return (
      <div className="timeline-data">
        <Row className="d-flex justify-content-end">
          <Col sm={1} md={1} lg={1} className="zoom-borders">
            <div className="border-icons border-icons-left" id="MoveLeft" onClick={() => this.move(0.2)} >
              <img className='mr-1 timeline-icons' src={moveLeftIcon} alt=""/>
              <UncontrolledTooltip placement="top" target="MoveLeft">
                Move Left
              </UncontrolledTooltip>
            </div>
            <div className="border-icons" id="MoveRight" onClick={() => this.move(-0.2)} >
              <img className='mr-1 timeline-icons border-icons-right' src={moveRightIcon} alt=""/>
              <UncontrolledTooltip placement="top" target="MoveRight">
                Move Right
              </UncontrolledTooltip>
            </div>
          </Col>
          <Col sm={1} md={1} lg={1} className="zoom-borders">
                <div className="border-icons border-icons-left" id="ZoomIn" onClick={this.zoomIn}>
                  <img id="ZoomIn" src={zoomInIcon} alt=""/>
                  <UncontrolledTooltip placement="top" target="ZoomIn">
                    Zoom In
                  </UncontrolledTooltip>
                </div>
                <div className="border-icons border-icons-right" id="ZoomOut" onClick={this.zoomOut}>
                  <img src={zoomOutIcon} alt=""/>
                  <UncontrolledTooltip placement="top" target="ZoomOut">
                  Zoom Out
                  </UncontrolledTooltip>
                </div>
          </Col>
        </Row>
        <div style={{ background: "white" }}>
          <Timeline
            ref={this.timeline}
            {...this.state.timelineData}
            clickHandler={this.clickHandler.bind(this)}
            selection={this.state.selectedIds}
          />
        </div>
      </div>
    )
  }
  clickHandler(props) {
    const { group } = props
    const selectedIds = this.state.timelineData.items
      .filter(item => item.group === group)
      .map(item => item.id)
    this.setState({
      selectedIds,
    })
  }
  zoomIn() {
    if (this.timeline.current) {
      this.timeline.current.$el.zoomIn(0.2)
    }
  }
  zoomOut() {
    if (this.timeline.current) {
      this.timeline.current.$el.zoomOut(0.2)
    }
  }
  move(percentage) {
    if (this.timeline.current) {
      let timeline = this.timeline.current.$el
      var range = timeline.getWindow();
      var interval = range.end - range.start;

      let max_date = new Date(this.props.max)
      max_date.setDate(max_date.getDate() + 15);

      let end = range.end.valueOf() - interval * percentage

      if (percentage < 0 && range.end.valueOf() >= max_date.valueOf()) {

      }

      else if (percentage < 0 && end > max_date.valueOf()) {
        timeline.setWindow({
          end: max_date.valueOf()
        });
      }

      else {
        timeline.setWindow({
          start: range.start.valueOf() - interval * percentage,
          end: range.end.valueOf() - interval * percentage
        });
      }

    }
  }
}



export default ResultTimeline



